import { gql } from "types";

export const GET_USER = gql(/* GraphQL */ `
  query GetUser {
    user {
      id
      idHash
      email
      notificationCenterOpenedAt
      unseenNotificationsCount
      profile {
        id
        name
      }
      userRoles {
        id
        role {
          id
          name
          isPlatform
          rolePermissions {
            id
            permission
          }
        }
        company {
          id
          name
        }
      }
      employments {
        id
        companyId
        company {
          id
          name
        }
      }
    }
  }
`);

export const GET_COMPANIES = gql(/* GraphQL */ `
  query GetCompanies($filters: FiltersExpression) {
    companiesList(filters: $filters) {
      count
      list {
        id
        name
      }
    }
  }
`);

export const FIND_COMPANY = gql(/* GraphQL */ `
  query FindCompany($id: String!) {
    company: findCompany(id: $id) {
      id
      name
      registeredNumber
      registeredAddress
      verificationStatus
      statusDismissed
      onboardingSteps {
        banking
        benefits
        employees
        admins
        tax
      }
      bankingDetails {
        id
        companyId
        bankName
        bankCountry
        payeeAccountName
        payeeSWIFT
        iban
      }
      tradingBankAccount {
        bankName
        iban
        bankLocation
      }
      verificationDetails {
        id
        industry
      }
      fatcaDetails
    }
  }
`);

export const GET_FUNDS = gql(/* GraphQL */ `
  query GetFunds {
    funds {
      id
      nameEn
      nameAr
    }
  }
`);

export const GET_USERS = gql(/* GraphQL */ `
  query GetUsers(
    $companyId: String
    $pagination: Pagination
    $filters: FiltersExpression
    $orderBy: UsersListOrderByInput
    $roleScope: [String!]
  ) {
    usersList(
      companyId: $companyId
      pagination: $pagination
      filters: $filters
      orderBy: $orderBy
      roleScope: $roleScope
    ) {
      count
      list {
        id
        email
        isVerified
        updatedAt
        userRoles {
          id
          company {
            id
            name
          }
          role {
            id
            name
          }
        }
        profile {
          name
          id
        }
        adminInvitations {
          id
          email
        }
        employments {
          id
          company {
            id
            name
          }
        }
        blockedAt
      }
    }
  }
`);
